import Vue from 'vue';
import VueFormGenerator from 'vue-form-generator';

Vue.component('fieldCustomTextArea', {
  ...VueFormGenerator.component.components.formGroup.components.fieldTextArea,
});



// WEBPACK FOOTER //
// ./node_modules/@triotech/vue-core/src/vendor/vue-form-generator/fields/fieldCustomTextArea.js